// Métadonnées du composant Glass_NavBar
import type { ComponentMetadata } from '../../../G&CSCM/Core/types';

export interface Glass_NavBarParams {
    tinted: boolean;
}

export const Glass_NavBarConfig: ComponentMetadata = {
    name: 'Glass_NavBar',
    displayName: 'Glass Navigation Bar',
    description: 'Barre de navigation avec effet glass morphism',
    category: 'Navigation',
    defaultParams: {
        tinted: false
    },
    paramDefinitions: {
        tinted: {
            type: 'boolean',
            label: 'Teinté',
            description: 'Applique un effet de teinte au verre',
            editable_by_dev: true,
            editable_by_user: false  // Les utilisateurs ne doivent pas modifier l'apparence de la navbar
        }
    },
    outsideGrid: true, // Ce composant doit être hors de la grille par défaut
    defaultEnabled: true
};

export default Glass_NavBarConfig;

